/**
 * Utility function to construct proper image URLs for Laravel backend
 */

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 
                      process.env.REACT_APP_BACKEND_API || 
                      "https://nyam.pitech.co.tz";



/**
 * Constructs a proper image URL from a relative or absolute path
 * @param {string} imagePath - The image path from the API
 * @param {string} fallbackImage - Fallback image path (default: '/default-image.jpg')
 * @returns {string} - Complete image URL
 */
export const getImageUrl = (imagePath) => {
    // If no image path provided, return null
    if (!imagePath) {
        return null;
    }
    
    // If it's already a full URL, use it as-is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }
    
    let finalUrl;
    
    // Clean up the base URL to avoid double slashes
    const baseUrl = IMAGE_BASE_URL.endsWith('/') ? IMAGE_BASE_URL.slice(0, -1) : IMAGE_BASE_URL;
    
    // Handle different Laravel storage patterns
    if (imagePath.startsWith('storage/')) {
        // Direct storage path: storage/uploads/image.jpg
        finalUrl = `${baseUrl}/${imagePath}`;
    }
    else if (imagePath.startsWith('/storage/')) {
        // Absolute storage path: /storage/uploads/image.jpg
        finalUrl = `${baseUrl}${imagePath}`;
    }
    else if (imagePath.startsWith('/')) {
        // Other absolute paths
        finalUrl = `${baseUrl}${imagePath}`;
    }
    else {
        // Relative paths - assume they need storage/ prefix
        finalUrl = `${baseUrl}/storage/${imagePath}`;
    }
    
    // Clean up any double slashes in the final URL (except after protocol)
    finalUrl = finalUrl.replace(/([^:])\/\/+/g, '$1/');
    
    return finalUrl;
};



export default getImageUrl;